import { render, staticRenderFns } from "./field_manage.vue?vue&type=template&id=1d8366ba&scoped=true"
import script from "./field_manage.vue?vue&type=script&lang=js"
export * from "./field_manage.vue?vue&type=script&lang=js"
import style0 from "./field_manage.vue?vue&type=style&index=0&id=1d8366ba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8366ba",
  null
  
)

export default component.exports